export function isReservationNotFoundError(error?: {status?: number} | null): boolean {
  return error?.status === 404 || error?.status === 410;
}
